/**
 *  Define service to process get a quote form request
 */
import * as crypto from 'crypto-js';


export class LocalService {
    /**
     * Set value in local storage
     * @method set
     * @param  {string} key
     * @param  {any}    value
     * @return {any}
     */
    static set(key: string, value:any): any {
      value = LocalService.bsEncrypt(value);
      localStorage.setItem(key, value);
    }

    /**
     * Get value form local storage
     * @method get
     * @param  {string} key
     * @param  {boolean} prefix
     * @return {any}
     */
    static get(key: string): any {
      let data = localStorage.getItem(key);
      data = LocalService.bsDecrypt(data);
      if (data != null) {
        try {
          return JSON.parse(data);
        } catch (error) {
          console.log(error);
        }
      }
      return null;
    }

    /**
     * clear local storage
     * @param  {string} key
     * @method flush
     */
    static flush(key?: string) {
      if (key != null && key != undefined) {
          localStorage.removeItem(key);
      } else {
          localStorage.clear();
      }
    }

    /**
     * use to encrypt data
     * @method bsEncrypt
     * @param  {string}  data
     * @return {string}
     */
    static bsEncrypt(data: string) {
        let string: any = JSON.stringify(data);
        return crypto.AES.encrypt(string, 'asdfasfd').toString();
    }

    /**
     * use to decrypt data
     * @method bsDecrypt
     * @param  {string}  data
     * @return {string}
     */
    static bsDecrypt(data: string) {
      if (!data) {
          return data;
      }
      let string: any = crypto.AES.decrypt(data, 'asdfasfd');
      return string.toString(crypto.enc.Utf8);
    }
}